<template>
  <v-container
    fluid
    grid-list-xl
  >
    <v-layout
      row
      wrap
    >
      <v-flex
        xs12
      >
        <MassActionSelect
          :actions="massActions"
          @action-selected="dispatchAction"
        />

        <v-data-table
          v-model="selected"
          :loading="loading"
          :headers="headers"
          :items="collection"
          :total-items="meta.totalItems"
          :rows-per-page-text="$t('Rows per page')"
          :rows-per-page-items="meta.rowsPerPageItems"
          :pagination.sync="pagination"
          show-select
          select-all
          class="elevation-1"
          item-key="id"
        >
          <v-progress-linear
            slot="progress"
            color="primary"
            indeterminate
          />

          <template v-slot:items="props">
            <QuoteDataTableRow
              :props="props"
            />
          </template>
          <template v-slot:pageText="props">
            <span>{{ $t('{0} - {1} of {2}', [props.pageStart, props.pageStop, props.itemsLength]) }}</span>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import QuoteDataTableRow from '../components/QuoteDataTableRow'
import MassActionSelect from '../../../vuetify-console/components/MassActionSelect'

import { createNamespacedHelpers } from 'vuex'
const { mapActions, mapGetters } = createNamespacedHelpers('sales/quotes')

export default {
  name: 'QuoteList',

  components: {
    QuoteDataTableRow,
    MassActionSelect
  },

  actionBar () {
    return {
      title: 'Quotes',
      actions: [
        {
          text: 'Create Quote',
          event: 'add'
        }
      ]
    }
  },

  data () {
    return {
      selected: [],
      searchQuery: ''
    }
  },

  computed: {
    ...mapGetters(['collection', 'loading', 'meta', 'appliedFilters']),

    pagination: {
      get: function () {
        return this.meta
      },
      set: function (value) {
        this.applyMeta(value)
      }
    },

    headers () {
      return [
        { text: this.$t('Number'), value: 'id' },
        { text: this.$t('Name'), value: 'name' },
        { text: this.$t('Item Count'), value: 'count' },
        { text: this.$t('Total'), value: 'total' },
        { text: this.$t('Created By'), value: 'created_by.name' },
        { text: this.$t('Created From'), value: 'created_by.from' },
        { text: this.$t('Created At'), value: 'created_at' }
      ]
    },

    massActions () {
      return [
        { code: 'delete', label: this.$t('Delete') }
      ]
    }
  },

  methods: {
    ...mapActions(['applyMeta', 'fetchCollection', 'removeFilter', 'clearFilters']),

    setSearchQuery (query) {
      this.searchQuery = query
    },

    onActionAdd () {
      this.$router.push({ name: 'draft-order' })
    },

    dispatchAction (action) {
      if (action === 'delete') {
        this.deleteSelected()
      }
    },

    async deleteSelected () {
      let carts = null
      if (this.selected.length) {
        carts = this.selected.map(item => item.id)
      }

      await this.$http.make('cart').massDelete(carts)
      this.selected = []
      this.$toast.success(this.$t('Deleting records.'))
    }
  }
}
</script>
